import React from 'react';
import { Typography, Space } from 'antd';
import NPSDistributionChart from '../../graphics/npsDistributionChart';

const { Text } = Typography;

// 🔹 Función de transformación
function buildChartDataFromSubdimension(counts, counts_by_relationship) {
    const data = [];

    // 1) Agregar cada relación
    for (const [relation, relCounts] of Object.entries(counts_by_relationship)) {
        const scores = Array.from({ length: 10 }, (_, i) => {
            const score = i + 1;
            return { score, count: relCounts[score.toString()] || 0 };
        });

        data.push({ label: relation, scores });
    }

    return data;
}

const LeadershipNPSIndividual = ({
    average,
    nps,
    promoters,
    neutral,
    detractors,
    question,
    counts,
    counts_by_relationship,
    detractors_count,
    neutral_count,
    promoters_count,
    showNPS
}) => {
    // 🔹 Transformar data
    const chartData = buildChartDataFromSubdimension(counts, counts_by_relationship);

    return (
        <Space direction="vertical" size="large" style={{ width: '100%', marginTop: 20 }}>
            {/* Mostrar la pregunta */}
            <Text>{question.split('\n')[0]}</Text>

            {/* Renderizar gráfico con la data ya transformada */}
            <NPSDistributionChart 
                data={chartData} 
                promoters={promoters}
                detractors={detractors}
                nps={nps}
                detractors_count={detractors_count}
                neutral_count={neutral_count}
                promoters_count={promoters_count}
                showNPS={showNPS}
            />
        </Space>
    );
};

export default LeadershipNPSIndividual;
